const t = (key: string, options?: Record<string, unknown>) => window.i18n.t(key, options)

interface DiscoverResultsHeaderProps {
  numberOfDomains: number
}

export function DiscoverResultsHeader({
  numberOfDomains,
}: DiscoverResultsHeaderProps) {
  return (
    <header className="board-box__header">
      <h1 className="board-box__title">
        {t("js.discover.index.results_match_your_filters", {
          count: numberOfDomains,
          results: numberOfDomains.toLocaleString(),
        })}
      </h1>
    </header>
  )
}
